

















































import Vue from 'vue'
import { mapGetters } from 'vuex'
import { bus } from '../main'

/* eslint-disable */ 
import { Model } from '../models/Model'
/* eslint-enable */ 

export default Vue.extend({
  data () {
    return {    
    }
  },
  computed: {
    ...mapGetters({
      currentDealer: 'dealers/currentDealer',
      currentMake: 'makes/currentMake',
      carouselModels: 'models/carouselModels',
      loading: 'models/loading'
    }),
    columns() : number {
      const { xs, sm } = this.$vuetify.breakpoint
      return xs ? 1 : sm ? 2 : 3
    }
  },
  methods: {
    carouselItemClick(model : Model) {
      bus.$emit('carouselItemClicked', model)
    }
  }
})
